import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { PlatformLocation } from '@angular/common';
import { environment } from '../environments/environment';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, takeUntil } from 'rxjs/operators';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'ftl-quote-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ftl-shipments';

  constructor(
    private platformLocation: PlatformLocation,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.platformLocation.onPopState(() => {
      this.handleBackButton();
    });
  }

  handleBackButton() {
    console.log('backbutton pressed');
    const hash  = window.location.hash;
    if (hash.startsWith('#id_token')) {
      //window.history.go(-2);
      window.location.href = environment.traxClientUrl;
    }
  }

  authenticated(): boolean {
    return (this.authService.isLoggedIn());
  }
}
